import React, { useEffect, useRef, useState } from "react";
import { CSSTransition } from "react-transition-group";
import Button from "../../../../../server/public/shared/ui/inputs/classicButton.js";
import "./window.css";
import TabButton from "./tabButton.js";
import { useAutoAnimate } from "@formkit/auto-animate/react";
import { useHotkeyContext } from "src/merchant/v2/HotkeyContext/hotkeyContext.js";
import { confirm } from "shared/ui/ConfirmationManager/ConfirmationManager.js";
export default function WindowComponent(props) {
    var _a;
    const { tabBuilder } = props;
    const [openedTab, setOpenedTab] = useState(0);
    const currentTabIndex = useRef(0);
    const [parentRef] = useAutoAnimate();
    const { lock, unlock } = useHotkeyContext();
    function removeTab(index) {
        var _a, _b, _c, _d;
        const newTabs = tabs.filter((tab) => tab.index !== index);
        const removedTabArrayIndex = tabs.findIndex((tab) => tab.index === index);
        setTabs(newTabs);
        setOpenedTab((_d = (_b = (_a = newTabs[removedTabArrayIndex]) === null || _a === void 0 ? void 0 : _a.index) !== null && _b !== void 0 ? _b : (_c = newTabs[0]) === null || _c === void 0 ? void 0 : _c.index) !== null && _d !== void 0 ? _d : 0);
    }
    function buildNewTab() {
        const index = currentTabIndex.current++;
        return tabBuilder(index, (newTitle) => setTabs((old) => {
            return old.map((tab) => tab.index === index ? { ...tab, title: newTitle } : tab);
        }), () => {
            removeTab(index);
        });
    }
    const [open, setOpen] = useState(true);
    const [tabs, setTabs] = useState(() => tabBuilder ? [buildNewTab()] : []);
    useEffect(() => {
        if (open)
            lock();
        else
            unlock();
    }, [open]);
    useEffect(() => {
        if (props.exit)
            setOpen(false);
    }, [props.exit]);
    useEffect(() => {
        window.onbeforeunload = (e) => {
            if (tabs.length > 0) {
                e.preventDefault();
                e.returnValue = "";
            }
        };
        return () => (window.onbeforeunload = undefined);
    }, [tabs]);
    return (React.createElement("div", { className: ((_a = props.extraClasses) !== null && _a !== void 0 ? _a : "") + " window-container window-container-open" },
        React.createElement(CSSTransition, { in: open, timeout: 200, unmountOnExit: true, onEnter: () => { }, onExited: () => {
                props.onExited();
            }, classNames: "window window" },
            React.createElement("div", { className: open ? "window window-enter-active" : "window" },
                React.createElement("div", { className: "window-constant" + (tabBuilder ? " window-with-tabs" : "") },
                    tabBuilder ?
                        React.createElement("div", { className: "window-tabs-container", ref: parentRef },
                            tabs.map((tab) => (React.createElement(TabButton, { onOpenedTabChange: setOpenedTab, onRemoveTab: removeTab, openedTab: openedTab, tab: tab, key: tab.id }))),
                            React.createElement(Button, { version: "filled-tonal", key: "add-tab", classNames: "window-tab-button window-tab-button-add", onClick: () => {
                                    const newTab = buildNewTab();
                                    setTabs((t) => [...t, newTab]);
                                    setOpenedTab(newTab.index);
                                } }, "+"))
                        : React.createElement("div", { className: "window-title" }, props.title),
                    React.createElement("button", { onClick: async () => {
                            var _a;
                            if (props.disableExit === true)
                                return;
                            if (tabs.length > 1) {
                                const result = await confirm({
                                    title: "Czy na pewno chcesz zamknąć to okno?",
                                    message: "Masz otwarte więcej niż jedną kartę. Postęp może zostać utracony.",
                                });
                                if (!result)
                                    return;
                            }
                            setOpen(false);
                            (_a = props.onExit) === null || _a === void 0 ? void 0 : _a.call(props);
                        }, className: "window-closer" }, "\u2716")),
                tabs.map((tab) => (React.createElement("div", { className: openedTab === tab.index ? "tab-visible" : "tab-invisible", key: tab.index }, tab.content))),
                props.children))));
}
